export const RESET = 'RESET_LICENSES'

export const GET_LICENSES = 'GET_LICENSES'
export const SET_LICENSES = 'SET_LICENSES'

export const SET_LICENSE = 'SET_LICENSE'

